import { Cluster, Statistic } from "../model/analytics/types";

export const formatEventsCounter = (statistics: Statistic[]) => {
    const data = Object.entries(statistics).map(([key, val]) => ({
        id: key,
        label: key,
        value: val.counter
    }))
    return data;
}

export  const formatEventsDuration = (statistics: Statistic[]) => {
    const data = Object.entries(statistics).map(([key, val]) => ({
        key: key,
        averageMilliseconds: val.averageMilliseconds.toFixed(2) + " ms",
        minMilliseconds: val.minMilliseconds.toFixed(2) + " ms",
        maxMilliseconds: val.maxMilliseconds.toFixed(2) + " ms"
    }))
    return data;
}

export  const formatEventsCluster = (calls: Cluster[], durations : number[]) => {
    const data: any[] = []
    calls.map((item, i) => {
        if (item.averageMilliseconds > durations[0] && item.averageMilliseconds < durations[1])
            data.push(
                {
                    id: i.toString(),
                    group: item.type,
                    duration: item.averageMilliseconds,
                    volume: 7,
                    range: item.millisecondsRange,
                    callIds: item.callIds,
                    eventCounter: item.eventCounter,
                }
            )
    })
    return data;
}

export const formatEventCluster = (calls: Cluster[]) => {
    const data: any[] = []
    calls.map((item, i) => {
        data.push({
            x: item.eventCounter,
            y: item.averageMilliseconds,
            range: item.millisecondsRange,
            callIds: item.callIds,
            eventCounter: item.eventCounter,
        })
    })
    return [{
        data: data
    }]
}

export const getEventAverageTime = (statistics : Statistic[], event : string): number | undefined => {
    var averageTime;
    Object.entries(statistics).map(([key, val]) => {
        if (key === event) {
            averageTime = val.averageMilliseconds.toFixed(2)
        }
    })
    return averageTime
}

export const columns = [
  {
    title: 'Événement',
    dataIndex: 'key',
    key: 'key',
  },
  {
    title: 'Durée moyenne',
    dataIndex: 'averageMilliseconds',
    key: 'averageMilliseconds',
  },
  {
    title: 'Durée minimale',
    dataIndex: 'minMilliseconds',
    key: 'minMilliseconds',
    },
  {
    title: 'Durée maximale',
    dataIndex: 'maxMilliseconds',
    key: 'maxMilliseconds',
  },
];
